export const TOC_WIDTH = 302
export const SIDE_BAR_WIDTH = 56
export const DEFAULT_LATITUDE = 39.742043
export const DEFAULT_LONGITUDE = -104.991531
export const DEFAULT_ZOOM = 5

export const DEFAULT_HOME = {
  x: DEFAULT_LATITUDE,
  y: DEFAULT_LONGITUDE,
  z: DEFAULT_ZOOM,
}
